import type { ReactNode } from 'react';

import { Box } from '../../../../../common/ui/Box';
import { OfferActionsGrid } from '../../../common/OfferCard/OfferActionsGrid';
import { ActionsRow } from '../../../components/OfferCard/components/ActionsRow';
import { OfferStatus } from '../../../components/OfferCard/components/OfferStatus';
import { PriceAvailabilityStatus } from '../../../components/OfferCard/components/PriceAvailabilityStatus';

interface OfferStatusDisplayProps {
    additionalMessage?: ReactNode;
    showActions?: boolean;
}

export const OfferStatusDisplay = ({ additionalMessage, showActions = true }: OfferStatusDisplayProps) => {
    return (
        <OfferActionsGrid>
            <Box display="grid" rowGap={4}>
                {additionalMessage ? (
                    <Box display="grid" rowGap={8}>
                        <OfferStatus />
                        {additionalMessage}
                    </Box>
                ) : (
                    <OfferStatus />
                )}

                <PriceAvailabilityStatus />
            </Box>

            {showActions ? <ActionsRow /> : null}
        </OfferActionsGrid>
    );
};
